const pageIds = [
  'celebrating',
  'yearbook',
  'symbols',
  'craft-inspiration',
  'your',
  'wear-images',
  'wear-it-your-way',
  'keepsake-cubes',
  'gifts'
]

const yearNumbers = {
  1: require('../img/celebrating/Yearbooks1.png'),
  3: require('../img/celebrating/Yearbooks3.png'),
  5: require('../img/celebrating/Yearbooks5.png'),
  7: require('../img/celebrating/Yearbooks7.png'),
  10: require('../img/celebrating/Yearbooks10.png'),
  15: require('../img/celebrating/Yearbooks15.png'),
  20: require('../img/celebrating/Yearbooks20.png'),
  25: require('../img/celebrating/Yearbooks25.png'),
  30: require('../img/celebrating/Yearbooks30.png'),
  35: require('../img/celebrating/Yearbooks35.png'),
  40: require('../img/celebrating/Yearbooks40.png'),
  45: require('../img/celebrating/Yearbooks45.png'),
  50: require('../img/celebrating/Yearbooks50.png'),
  55: require('../img/celebrating/Yearbooks55.png')
}

const symbols = {
  0: [
    { front: require('../img/symbol/00 JM Charm-1.png'), back: require('../img/symbol/00 JM Charm-2.jpg'), name: 'JM Charm' },
    { front: require('../img/symbol/00 JM Keychain-1.png'), back: require('../img/symbol/00 JM Keychain-2.jpg'), name: 'JM Keychain' },
    { front: require('../img/symbol/00 JM Luggage Tag-1.png'), back: require('../img/symbol/00 JM Luggage Tag-2.jpg'), name: 'JM Luggage Tag' },
    { front: require('../img/symbol/00 JM Pin-1.png'), back: require('../img/symbol/00 JM Pin-2.jpg'), name: 'JM Pin' },
    { front: require('../img/symbol/00 JM Tie Chain Bar-1.png'), back: require('../img/symbol/00 JM Tie Chain Bar-2.jpg'), name: 'JM Tie Chain Bar' },
    { front: require('../img/symbol/00 JM Zipper Pull-1.png'), back: require('../img/symbol/00 JM Zipper Pull-2.jpg'), name: 'JM Zipper Pull' }
  ],
  1: [
    { front: require('../img/symbol/01 Atom Charm-1.png'), back: require('../img/symbol/01 Atom Charm-2.jpg'), name: 'Atom Charm' },
    { front: require('../img/symbol/01 Atom Keychain-1.png'), back: require('../img/symbol/01 Atom Keychain-2.jpg'), name: 'Atom Keychain' },
    { front: require('../img/symbol/01 Atom Luggage Tag-1.png'), back: require('../img/symbol/01 Atom Luggage Tag-2.jpg'), name: 'Atom Luggage Tag' },
    { front: require('../img/symbol/01 Atom Pin-1.png'), back: require('../img/symbol/01 Atom Pin-2.jpg'), name: 'Atom Pin' },
    { front: require('../img/symbol/01 Atom Tie Chain Bar-1.png'), back: require('../img/symbol/01 Atom Tie Chain Bar-2.jpg'), name: 'Atom Tie Chain Bar' },
    { front: require('../img/symbol/01 Atom Zipper Pull-1.png'), back: require('../img/symbol/01 Atom Zipper Pull-2.jpg'), name: 'Atom Zipper Pull' }
  ],
  3: [
    { front: require('../img/symbol/03 Tree Charm-1.png'), back: require('../img/symbol/03 Tree Charm-2.jpg'), name: 'Tree Charm' },
    { front: require('../img/symbol/03 Tree Keychain-1.png'), back: require('../img/symbol/03 Tree Keychain-2.jpg'), name: 'Tree Keychain' },
    { front: require('../img/symbol/03 Tree Luggage Tag-1.png'), back: require('../img/symbol/03 Tree Luggage Tag-2.jpg'), name: 'Tree Luggage Tag' },
    { front: require('../img/symbol/03 Tree Pin-1.png'), back: require('../img/symbol/03 Tree Pin-2.jpg'), name: 'Tree Pin' },
    { front: require('../img/symbol/03 Tree Tie Chain Bar-1.png'), back: require('../img/symbol/03 Tree Tie Chain Bar-2.jpg'), name: 'Tree Tie Chain Bar' },
    { front: require('../img/symbol/03 Tree Zipper Pull-1.png'), back: require('../img/symbol/03 Tree Zipper Pull-2.jpg'), name: 'Tree Zipper Pull' }
  ],
  5: [
    { front: require('../img/symbol/05 DNA Charm-1.png'), back: require('../img/symbol/05 DNA Charm-2.jpg'), name: 'DNA Charm' },
    { front: require('../img/symbol/05 DNA Keychain-1.png'), back: require('../img/symbol/05 DNA Keychain-2.jpg'), name: 'DNA Keychain' },
    { front: require('../img/symbol/05 DNA Luggage Tag-1.png'), back: require('../img/symbol/05 DNA Luggage Tag-2.jpg'), name: 'DNA Luggage Tag' },
    { front: require('../img/symbol/05 DNA Pin-1.png'), back: require('../img/symbol/05 DNA Pin-2.jpg'), name: 'DNA Pin' },
    { front: require('../img/symbol/05 DNA Tie Chain Bar-1.png'), back: require('../img/symbol/05 DNA Tie Chain Bar-2.jpg'), name: 'DNA Tie Chain Bar' },
    { front: require('../img/symbol/05 DNA Zipper Pull-1.png'), back: require('../img/symbol/05 DNA Zipper Pull-2.jpg'), name: 'DNA Zipper Pull' }
  ],
  7: [
    { front: require('../img/symbol/07 Globe Charm-1.png'), back: require('../img/symbol/07 Globe Charm-2.jpg'), name: 'Globe Charm' },
    { front: require('../img/symbol/07 Globe Keychain-1.png'), back: require('../img/symbol/07 Globe Keychain-2.jpg'), name: 'Globe Keychain' },
    { front: require('../img/symbol/07 Globe Luggage Tag-1.png'), back: require('../img/symbol/07 Globe Luggage Tag-2.jpg'), name: 'Globe Luggage Tag' },
    { front: require('../img/symbol/07 Globe Pin-1.png'), back: require('../img/symbol/07 Globe Pin-2.jpg'), name: 'Globe Pin' },
    { front: require('../img/symbol/07 Globe Tie Chain Bar-1.png'), back: require('../img/symbol/07 Globe Tie Chain Bar-2.jpg'), name: 'Globe Tie Chain Bar' },
    { front: require('../img/symbol/07 Globe Zipper Pull-1.png'), back: require('../img/symbol/07 Globe Zipper Pull-2.jpg'), name: 'Globe Zipper Pull' }
  ],
  10: [
    { front: require('../img/symbol/10 Top Hat Charm-1.png'), back: require('../img/symbol/10 Top Hat Charm-2.jpg'), name: 'Top Hat Charm' },
    { front: require('../img/symbol/10 Top Hat Keychain-1.png'), back: require('../img/symbol/10 Top Hat Keychain-2.jpg'), name: 'Top Hat Keychain' },
    { front: require('../img/symbol/10 Top Hat Luggage Tag-1.png'), back: require('../img/symbol/10 Top Hat Luggage Tag-2.jpg'), name: 'Top Hat Luggage Tag' },
    { front: require('../img/symbol/10 Top Hat Pin-1.png'), back: require('../img/symbol/10 Top Hat Pin-2.jpg'), name: 'Top Hat Pin' },
    { front: require('../img/symbol/10 Top Hat Tie Chain Bar-1.png'), back: require('../img/symbol/10 Top Hat Tie Chain Bar-2.jpg'), name: 'Top Hat Tie Chain Bar' },
    { front: require('../img/symbol/10 Top Hat Zipper Pull-1.png'), back: require('../img/symbol/10 Top Hat Zipper Pull-2.jpg'), name: 'Top Hat Zipper Pull' }
  ],
  15: [
    { front: require('../img/symbol/15 Scale Charm-1.png'), back: require('../img/symbol/15 Scale Charm-2.jpg'), name: 'Scale Charm' },
    { front: require('../img/symbol/15 Scale Keychain-1.png'), back: require('../img/symbol/15 Scale Keychain-2.jpg'), name: 'Scale Keychain' },
    { front: require('../img/symbol/15 Scale Luggage Tag-1.png'), back: require('../img/symbol/15 Scale Luggage Tag-2.jpg'), name: 'Scale Luggage Tag' },
    { front: require('../img/symbol/15 Scale Pin-1.png'), back: require('../img/symbol/15 Scale Pin-2.jpg'), name: 'Scale Pin' },
    { front: require('../img/symbol/15 Scale Tie Chain Bar-1.png'), back: require('../img/symbol/15 Scale Tie Chain Bar-2.jpg'), name: 'Scale Tie Chain Bar' },
    { front: require('../img/symbol/15 Scale Zipper Pull-1.png'), back: require('../img/symbol/15 Scale Zipper Pull-2.jpg'), name: 'Scale Zipper Pull' }
  ],
  20: [
    { front: require('../img/symbol/20 Astronaut Charm-1.png'), back: require('../img/symbol/20 Astronaut Charm-2.jpg'), name: 'Astronaut Charm' },
    { front: require('../img/symbol/20 Astronaut Keychain-1.png'), back: require('../img/symbol/20 Astronaut Keychain-2.jpg'), name: 'Astronaut Keychain' },
    { front: require('../img/symbol/20 Astronaut Luggage Tag-1.png'), back: require('../img/symbol/20 Astronaut Luggage Tag-2.jpg'), name: 'Astronaut Luggage Tag' },
    { front: require('../img/symbol/20 Astronaut Pin-1.png'), back: require('../img/symbol/20 Astronaut Pin-2.jpg'), name: 'Astronaut Pin' },
    { front: require('../img/symbol/20 Astronaut Tie Chain Bar-1.png'), back: require('../img/symbol/20 Astronaut Tie Chain Bar-2.jpg'), name: 'Astronaut Tie Chain Bar' },
    { front: require('../img/symbol/20 Astronaut Zipper Pull-1.png'), back: require('../img/symbol/20 Astronaut Zipper Pull-2.jpg'), name: 'Astronaut Zipper Pull' }
  ],
  25: [
    { front: require('../img/symbol/25 Handshake Charm-1.png'), back: require('../img/symbol/25 Handshake Charm-2.jpg'), name: 'Handshake Charm' },
    { front: require('../img/symbol/25 Handshake Keychain-1.png'), back: require('../img/symbol/25 Handshake Keychain-2.jpg'), name: 'Handshake Keychain' },
    { front: require('../img/symbol/25 Handshake Luggage Tag-1.png'), back: require('../img/symbol/25 Handshake Luggage Tag-2.jpg'), name: 'Handshake Luggage Tag' },
    { front: require('../img/symbol/25 Handshake Pin-1.png'), back: require('../img/symbol/25 Handshake Pin-2.jpg'), name: 'Handshake Pin' },
    { front: require('../img/symbol/25 Handshake Tie Chain Bar-1.png'), back: require('../img/symbol/25 Handshake Tie Chain Bar-2.jpg'), name: 'Handshake Tie Chain Bar' },
    { front: require('../img/symbol/25 Handshake Zipper Pull-1.png'), back: require('../img/symbol/25 Handshake Zipper Pull-2.jpg'), name: 'Handshake Zipper Pull' }
  ],
  30: [
    { front: require('../img/symbol/30 Lightbulb Charm-1.png'), back: require('../img/symbol/30 Lightbulb Charm-2.jpg'), name: 'Lightbulb Charm' },
    { front: require('../img/symbol/30 Lightbulb Keychain-1.png'), back: require('../img/symbol/30 Lightbulb Keychain-2.jpg'), name: 'Lightbulb Keychain' },
    { front: require('../img/symbol/30 Lightbulb Luggage Tag-1.png'), back: require('../img/symbol/30 Lightbulb Luggage Tag-2.jpg'), name: 'Lightbulb Luggage Tag' },
    { front: require('../img/symbol/30 Lightbulb Pin-1.png'), back: require('../img/symbol/30 Lightbulb Pin-2.jpg'), name: 'Lightbulb Pin' },
    { front: require('../img/symbol/30 Lightbulb Tie Chain Bar-1.png'), back: require('../img/symbol/30 Lightbulb Tie Chain Bar-2.jpg'), name: 'Lightbulb Tie Chain Bar' },
    { front: require('../img/symbol/30 Lightbulb Zipper Pull-1.png'), back: require('../img/symbol/30 Lightbulb Zipper Pull-2.jpg'), name: 'Lightbulb Zipper Pull' }
  ],
  35: [
    { front: require('../img/symbol/35 Coin Charm-1.png'), back: require('../img/symbol/35 Coin Charm-2.jpg'), name: 'Coin Charm' },
    { front: require('../img/symbol/35 Coin Keychain-1.png'), back: require('../img/symbol/35 Coin Keychain-2.jpg'), name: 'Coin Keychain' },
    { front: require('../img/symbol/35 Coin Luggage Tag-1.png'), back: require('../img/symbol/35 Coin Luggage Tag-2.jpg'), name: 'Coin Luggage Tag' },
    { front: require('../img/symbol/35 Coin Pin-1.png'), back: require('../img/symbol/35 Coin Pin-2.jpg'), name: 'Coin Pin' },
    { front: require('../img/symbol/35 Coin Tie Chain Bar-1.png'), back: require('../img/symbol/35 Coin Tie Chain Bar-2.jpg'), name: 'Coin Tie Chain Bar' },
    { front: require('../img/symbol/35 Coin Zipper Pull-1.png'), back: require('../img/symbol/35 Coin Zipper Pull-2.jpg'), name: 'Coin Zipper Pull' }
  ],
  40: [
    { front: require('../img/symbol/40 JM Car Charm-1.png'), back: require('../img/symbol/40 JM Car Charm-2.jpg'), name: 'JM Car Charm' },
    { front: require('../img/symbol/40 JM Car Keychain-1.png'), back: require('../img/symbol/40 JM Car Keychain-2.jpg'), name: 'JM Car Keychain' },
    { front: require('../img/symbol/40 JM Car Luggage Tag-1.png'), back: require('../img/symbol/40 JM Car Luggage Tag-2.jpg'), name: 'JM Car Luggage Tag' },
    { front: require('../img/symbol/40 JM Car Pin-1.png'), back: require('../img/symbol/40 JM Car Pin-2.jpg'), name: 'JM Car Pin' },
    { front: require('../img/symbol/40 JM Car Tie Chain Bar-1.png'), back: require('../img/symbol/40 JM Car Tie Chain Bar-2.jpg'), name: 'JM Car Tie Chain Bar' },
    { front: require('../img/symbol/40 JM Car Zipper Pull-1.png'), back: require('../img/symbol/40 JM Car Zipper Pull-2.jpg'), name: 'JM Car Zipper Pull' }
  ],
  45: [
    { front: require('../img/symbol/45 Heart Charm-1.png'), back: require('../img/symbol/45 Heart Charm-2.jpg'), name: 'Heart Charm' },
    { front: require('../img/symbol/45 Heart Keychain-1.png'), back: require('../img/symbol/45 Heart Keychain-2.jpg'), name: 'Heart Keychain' },
    { front: require('../img/symbol/45 Heart Luggage Tag-1.png'), back: require('../img/symbol/45 Heart Luggage Tag-2.jpg'), name: 'Heart Luggage Tag' },
    { front: require('../img/symbol/45 Heart Pin-1.png'), back: require('../img/symbol/45 Heart Pin-2.jpg'), name: 'Heart Pin' },
    { front: require('../img/symbol/45 Heart Tie Chain Bar-1.png'), back: require('../img/symbol/45 Heart Tie Chain Bar-2.jpg'), name: 'Heart Tie Chain Bar' },
    { front: require('../img/symbol/45 Heart Zipper Pull-1.png'), back: require('../img/symbol/45 Heart Zipper Pull-2.jpg'), name: 'Heart Zipper Pull' }
  ],
  50: [
    { front: require('../img/symbol/50 Gold Bar Charm-1.png'), back: require('../img/symbol/50 Gold Bar Charm-2.jpg'), name: 'Gold Bar Charm' },
    { front: require('../img/symbol/50 Gold Bar Keychain-1.png'), back: require('../img/symbol/50 Gold Bar Keychain-2.jpg'), name: 'Gold Bar Keychain' },
    { front: require('../img/symbol/50 Gold Bar Luggage Tag-1.png'), back: require('../img/symbol/50 Gold Bar Luggage Tag-2.jpg'), name: 'Gold Bar Luggage Tag' },
    { front: require('../img/symbol/50 Gold Bar Pin-1.png'), back: require('../img/symbol/50 Gold Bar Pin-2.jpg'), name: 'Gold Bar Pin' },
    { front: require('../img/symbol/50 Gold Bar Tie Chain Bar-1.png'), back: require('../img/symbol/50 Gold Bar Tie Chain Bar-2.jpg'), name: 'Gold Bar Tie Chain Bar' },
    { front: require('../img/symbol/50 Gold Bar Zipper Pull-1.png'), back: require('../img/symbol/50 Gold Bar Zipper Pull-2.jpg'), name: 'Gold Bar Zipper Pull' }
  ],
  55: [
    { front: require('../img/symbol/55 Platinum Charm-1.png'), back: require('../img/symbol/55 Platinum Charm-2.jpg'), name: 'Platinum Charm' },
    { front: require('../img/symbol/55 Platinum Keychain-1.png'), back: require('../img/symbol/55 Platinum Keychain-2.jpg'), name: 'Platinum Keychain' },
    { front: require('../img/symbol/55 Platinum Luggage Tag-1.png'), back: require('../img/symbol/55 Platinum Luggage Tag-2.jpg'), name: 'Platinum Luggage Tag' },
    { front: require('../img/symbol/55 Platinum Pin-1.png'), back: require('../img/symbol/55 Platinum Pin-2.jpg'), name: 'Platinum Pin' },
    { front: require('../img/symbol/55 Platinum Tie Chain Bar-1.png'), back: require('../img/symbol/55 Platinum Tie Chain Bar-2.jpg'), name: 'Platinum Tie Chain Bar' },
    { front: require('../img/symbol/55 Platinum Zipper Pull-1.png'), back: require('../img/symbol/55 Platinum Zipper Pull-2.jpg'), name: 'Platinum Zipper Pull' }
  ]
}

const mainSymbols = {
  0: { label: 'Material: White Brass', img: require('../img/your/00JM.png') },
  1: { label: 'Material: 1/10 Gold Fill', img: require('../img/your/01Atom.png') },
  3: { label: 'Material: Sterling Silver 925', img: require('../img/your/03Tree.png') },
  5: { label: 'Material: 1/10 Gold Fill', img: require('../img/your/05DNA.png') },
  7: { label: 'Material: Sterling Silver 925', img: require('../img/your/07_Globe.png') },
  10: { label: 'Material: Yellow Brass', img: require('../img/your/10_TopHat.png') },
  15: { label: 'Material: 1/10 Gold Fill', img: require('../img/your/15Scale.png') },
  20: { label: 'Material: Sterling Silver 925', img: require('../img/your/20Astronaut.png') },
  25: { label: 'Material: 10K Gold', img: require('../img/your/25Handshake.png') },
  30: { label: 'Material: Epoch&trade; Metal', img: require('../img/your/30Lightbulb.png') },
  35: { label: 'Material: 10K Gold', img: require('../img/your/35Coin.png') },
  40: { label: 'Material: Epoch&trade; Metal', img: require('../img/your/40JM_Car.png') },
  45: { label: 'Material: 10K Gold', img: require('../img/your/45Heart.png') },
  50: { label: 'Material: 10K Gold', img: require('../img/your/50Gold Bar.png') },
  55: { label: 'Material: 10K Gold', img: require('../img/your/55Platinum.png') }
}

const giftsImages = {
  5: [
    require('../img/gifts/5/3_Im8.jpeg'),
    require('../img/gifts/5/4_Im13.jpeg'),
    require('../img/gifts/5/4_Im15.jpeg'),
    require('../img/gifts/5/5_Im23.jpeg'),
    require('../img/gifts/5/6_Im25.jpeg'),
    require('../img/gifts/5/6_Im27.jpeg'),
    require('../img/gifts/5/7_Im35.jpeg'),
    require('../img/gifts/5/8_Im37.jpeg')
  ],
  7: [
    require('../img/gifts/7/12_Im59.jpeg'),
    require('../img/gifts/7/12_Im60.jpeg'),
    require('../img/gifts/7/14_Im72.jpeg'),
    require('../img/gifts/7/15_Im79.jpeg'),
    require('../img/gifts/7/16_Im86.jpeg'),
    require('../img/gifts/7/16_Im87.jpeg'),
    require('../img/gifts/7/19_Im104.jpeg'),
    require('../img/gifts/7/19_Im105.jpeg')
  ],
  10: [
    require('../img/gifts/10/23_Im123.jpeg'),
    require('../img/gifts/10/24_Im130.jpeg'),
    require('../img/gifts/10/26_Im140.jpeg'),
    require('../img/gifts/10/27_Im148.jpeg'),
    require('../img/gifts/10/29_Im161.jpeg'),
    require('../img/gifts/10/30_Im163.jpeg'),
    require('../img/gifts/10/30_Im167.jpeg'),
    require('../img/gifts/10/31_Im170.jpeg')
  ],
  15: [
    require('../img/gifts/15/35_Im189.jpeg'),
    require('../img/gifts/15/36_Im198.jpeg'),
    require('../img/gifts/15/37_Im199.jpeg'),
    require('../img/gifts/15/37_Im203.jpeg'),
    require('../img/gifts/15/38_Im209.jpeg'),
    require('../img/gifts/15/41_Im223.jpeg'),
    require('../img/gifts/15/42_Im230.jpeg'),
    require('../img/gifts/15/42_Im231.jpeg')
  ],
  20: [
    require('../img/gifts/20/46_Im250.jpeg'),
    require('../img/gifts/20/48_Im260.jpeg'),
    require('../img/gifts/20/48_Im262.jpeg'),
    require('../img/gifts/20/49_Im266.jpeg'),
    require('../img/gifts/20/49_Im268.jpeg'),
    require('../img/gifts/20/51_Im278.jpeg'),
    require('../img/gifts/20/51_Im280.jpeg'),
    require('../img/gifts/20/51_Im282.jpeg')
  ],
  25: [
    require('../img/gifts/25/54_Im292.jpeg'),
    require('../img/gifts/25/54_Im294.jpeg'),
    require('../img/gifts/25/54_Im297.jpeg'),
    require('../img/gifts/25/56_Im306.jpeg'),
    require('../img/gifts/25/56_Im308.jpeg'),
    require('../img/gifts/25/57_Im314.jpeg'),
    require('../img/gifts/25/57_Im315.jpeg'),
    require('../img/gifts/25/58_Im316.jpeg')
  ],
  30: [
    require('../img/gifts/30/60_Im326.jpeg'),
    require('../img/gifts/30/60_Im328.jpeg'),
    require('../img/gifts/30/61_Im331.jpeg'),
    require('../img/gifts/30/61_Im333.jpeg'),
    require('../img/gifts/30/62_Im338.jpeg'),
    require('../img/gifts/30/63_Im343.jpeg'),
    require('../img/gifts/30/64_Im348.jpeg'),
    require('../img/gifts/30/65_Im354.jpeg')
  ],
  35: [
    require('../img/gifts/35/67_Im363.jpeg'),
    require('../img/gifts/35/68_Im369.jpeg'),
    require('../img/gifts/35/68_Im370.jpeg'),
    require('../img/gifts/35/69_Im373.jpeg'),
    require('../img/gifts/35/69_Im374.jpeg'),
    require('../img/gifts/35/69_Im375.jpeg'),
    require('../img/gifts/35/69_Im377.jpeg'),
    require('../img/gifts/35/70_Im381.jpeg')
  ],
  40: [
    require('../img/gifts/40/73_Im393.jpeg'),
    require('../img/gifts/40/73_Im397.jpeg'),
    require('../img/gifts/40/74_Im398.jpeg'),
    require('../img/gifts/40/74_Im402.jpeg'),
    require('../img/gifts/40/74_Im403.jpeg'),
    require('../img/gifts/40/75_Im408.jpeg'),
    require('../img/gifts/40/77_Im419.jpeg'),
    require('../img/gifts/40/77_Im420.jpeg')
  ],
  45: [
    require('../img/gifts/45/81_Im437.jpeg'),
    require('../img/gifts/45/81_Im438.jpeg'),
    require('../img/gifts/45/82_Im441.jpeg'),
    require('../img/gifts/45/82_Im446.jpeg'),
    require('../img/gifts/45/83_Im447.jpeg'),
    require('../img/gifts/45/83_Im448.jpeg'),
    require('../img/gifts/45/83_Im451.jpeg'),
    require('../img/gifts/45/83_Im452.jpeg')
  ],
  50: [
    require('../img/gifts/50/86_Im459.jpeg'),
    require('../img/gifts/50/86_Im460.jpeg'),
    require('../img/gifts/50/86_Im462.jpeg'),
    require('../img/gifts/50/86_Im463.jpeg'),
    require('../img/gifts/50/87_Im464.jpeg'),
    require('../img/gifts/50/87_Im466.jpeg'),
    require('../img/gifts/50/87_Im467.jpeg'),
    require('../img/gifts/50/87_Im468.jpeg')
  ],
  55: [
    require('../img/gifts/55/88_Im469.jpeg'),
    require('../img/gifts/55/88_Im471.jpeg'),
    require('../img/gifts/55/89_Im475.jpeg'),
    require('../img/gifts/55/89_Im479.jpeg'),
    require('../img/gifts/55/89_Im480.jpeg'),
    require('../img/gifts/55/90_Im460.jpeg'),
    require('../img/gifts/55/90_Im481.jpeg'),
    require('../img/gifts/55/90_Im482.jpeg')
  ]
}

const yourDescriptions = {
  0: 'Our brand has been built on reputation and ' +
    'innovation for over 200 years. We welcome you ' +
    'to JM and ask you to live and wear our brand ' +
    'with the same pride as all those who have ' +
    'gone before.',
  1: 'We inspire science by creating innovative products ' +
    'and it all begins in the nucleus of an atom. We ' +
    'celebrate the first year of your JM journey and look ' +
    'to you to explore new paths and inspire us.',
  3: 'With our science, understanding and vision, we ' +
    'contribute to a more sustainable future. At three ' +
    'years we celebrate your connection and future ' +
    'with us as your roots take hold.',
  5: 'We are at the forefront of technology, taking ' +
    'science from the lab to the market to enhancing ' +
    'life. At your five year milestone we support and ' +
    'encourage you to grow and reach the next level.',
  7: 'We research, develop and deliver technologies ' +
    'to help build a cleaner and healthier world for ' +
    'everyone – protecting our planet and millions of ' +
    'people. Today you are one of more than 14,000 ' +
    'JM people who are helping us make a difference ' +
    'to the world around us.',
  10: 'In 1817 Percival Norton Johnson started our company. ' +
    'In 1838 a 13 year old apprentice named George ' +
    'Matthey joined and was taken into partnership in ' +
    '1851 when the company name was born. We are built ' +
    'on their legacy, and today you help us pioneer our way ' +
    'in science, drive our growth and build our future.',
  15: 'We manufactured the first ever standard metre ' +
    'and kilogramme, which are still used globally ' +
    'today. We remain committed to new challenges ' +
    'and at 15 years you are an integral part of setting ' +
    'JM’s standards.',
  20: 'JM developed high performance fuel cell systems ' +
    'used by NASA for the moon landings. Like ' +
    'mankind’s one giant leap, your 20 years is also a ' +
    'significant milestone. As you step forward in your ' +
    'JM journey we look forward to you continuing to ' +
    'make a difference to the world around us.',
  25: 'Our work spans the globe and our people build ' +
    'relationships, connect and collaborate to make ' +
    'a difference. At 25 years we celebrate the ' +
    'relationship we’ve built together and all the ways ' +
    'you’re part of the JM story.',
  30: 'In the early 1800s, we provided English scientist ' +
    'Humphry Davy with the platinum for his ' +
    'electrochemistry experiments. His commitment ' +
    'and innovation inspired the first electric light. At ' +
    '30 years you help us apply inspiring science to ' +
    'provide the world with innovative products.',
  35: 'From its very beginnings when it was appointed ' +
    'assayers and refiners to the Bank of England – ' +
    'the very highest of accolades – JM has built a ' +
    'reputation for quality and integrity. Over the past ' +
    '35 years you have contributed to this reputation ' +
    'and helped prepare JM for future generations.',
  40: 'In 1974 we used our expertise in platinum group ' +
    'chemistry to produce the first emission control ' +
    'catalyst. Today one in three cars are fitted with ' +
    'a JM catalyst. Your 40 years of expertise have ' +
    'helped us reduce millions of tonnes of pollutants ' +
    'from entering our atmosphere every day.',
  45: 'Our healthcare technologies help relieve pain and ' +
    'suffering for millions of people every year. People ' +
    'are at the heart of everything JM does and at 45 ' +
    'years you have made a significant contribution to ' +
    'making the lives of millions better.',
  50: 'At your golden anniversary, we honour you with ' +
    'a symbol that represents our golden beginnings ' +
    'as assayers in precious metals. It stands for ' +
    'your unique accomplishments, loyalty and our ' +
    'deepest thanks.',
  55: 'Platinum is the most precious of metals and has ' +
    'been an essential ingredient in our products ' +
    'and development through the years. At 55 years, ' +
    'your commitment and loyalty is precious to us ' +
    'and you’ve become a vital element to our success. ' +
    'Thank you.'
}

export {
  pageIds,
  yearNumbers,
  symbols,
  mainSymbols,
  giftsImages,
  yourDescriptions
}
